import * as Yup from 'yup'

export const schema = Yup.object().shape({
  date: Yup.date().nullable().required('A data é obrigatória.'),

  describeText: Yup.string().required('A descrição é obrigatória'),
})
